import React from "react"
import { Typography, Card } from "antd"
import { IconContext } from "react-icons"
import { FaReact, FaSass, FaJsSquare, FaPython, FaCss3, FaAngular, FaBootstrap, FaHtml5, FaNodeJs, } from "react-icons/fa"
import { SiRedux, SiPostgresql, SiAntdesign, SiNginx, SiCsharp, SiMicrosoftsqlserver, SiMysql, SiSqlite, SiLinux, SiAmazonaws, SiMicrosoftazure, SiApache, SiDocker } from "react-icons/si"
import aiChatgpt    from "../images/techstack/icons8-chatgpt-100.png"
import aiClaude     from "../images/techstack/icons8-claude-ai-100.png"
import aiLangchain  from "../images/techstack/langchain.png"
import aiElevenlabs from "../images/techstack/icons8-elevenlabs-100.png"
import aiPytorch    from "../images/techstack/icons8-pytorch-100.png"
import aiTensorflow from "../images/techstack/icons8-tensorflow-100.png"
import { GrGraphQl } from "react-icons/gr";
import "../styles/utilities.scss"
const { Title } = Typography

const TechStack = () => {
  return (
    <div className="tech-stack">
      <div className="heading">
        <Title>Web Development - Technology Stack</Title>
      </div>
      <div className="info-container">
        <div className="technologies_logos">
          <div className="language">
            <Title level={3}>Language</Title>
            <IconContext.Provider value={{ className: "service-tech-icons" }}>
              <div>
                <FaReact />
                <FaAngular />
                <FaNodeJs />
                <FaJsSquare />
                <FaSass />
                <SiRedux />
                <FaPython />
              </div>
            </IconContext.Provider>
            <div className="second-row">
              <IconContext.Provider value={{ className: "service-tech-icons" }}>
                <div>
                  <FaHtml5 />
                  <FaCss3 />
                  <FaBootstrap />
                  <SiCsharp />
                  <GrGraphQl />
                  <SiAntdesign />
                </div>
              </IconContext.Provider>
            </div>
          </div>
          <div className="database">
            <Title level={3}>Database</Title>
            <IconContext.Provider value={{ className: "service-tech-icons" }}>
              <div>
                <SiMicrosoftsqlserver />
                <SiPostgresql />
                <SiMysql />
                <SiSqlite />
              </div>
            </IconContext.Provider>
          </div>
          <div className="framework">
            <Title level={3}>Infrastructure</Title>
            <IconContext.Provider value={{ className: "service-tech-icons" }}>
              <div>
                <SiAmazonaws />
                <SiMicrosoftazure />
                <SiLinux />
                <SiNginx />
                <SiApache />
                <SiDocker />
              </div>
            </IconContext.Provider>
          </div>
          <div className="framework">
            <Title level={3}>AI & ML</Title>
            <div className="ai-icons-row">
              <img src={aiChatgpt}    alt="ChatGPT"     className="service-tech-img" />
              <img src={aiClaude}     alt="Claude AI"   className="service-tech-img" />
              <img src={aiTensorflow} alt="TensorFlow"  className="service-tech-img" />
              <img src={aiPytorch}    alt="PyTorch"     className="service-tech-img" />
              <img src={aiLangchain}  alt="LangChain"   className="service-tech-img" />
              <img src={aiElevenlabs} alt="ElevenLabs"  className="service-tech-img" />
            </div>
          </div>
        </div>
        <div style={{ height: "100%" }}>
          <Card style={{ width: "100%", height: "100%" }}>
            <Title level={3}>Full-Stack AI-Ready Technology Stack for Enterprise Web Development</Title>
            <p>
              We build web applications using modern, battle-tested languages and frameworks — React JS, Angular, Node.js, Python, C#, and GraphQL — with AI capabilities integrated at the code level, not bolted on afterwards. Every stack choice is made to support intelligent features, real-time data, and long-term scalability.
            </p>
            <p>
              Our database architecture is designed for high-throughput, AI-driven workloads. We work with Microsoft SQL Server, PostgreSQL, MySQL, and SQLite — selecting the right engine based on your data volume, query complexity, and the demands of any machine learning pipelines connected to your application.
            </p>
            <p>
              We deploy on cloud infrastructure built for resilience and scale — AWS, Microsoft Azure, Docker, Nginx, and Linux — giving your AI-powered application the low-latency, high-availability foundation it needs to perform in production, not just in demos.
            </p>
          </Card>
        </div>
      </div>
    </div>
  )
}

export default TechStack
